<template>
  <div class="flex flex-col gap-3 text-body text-text">
    <div>{{ t('task.manual_time_admin_required') }}</div>
    <div class="v-tracklify-scroll flex max-h-48 flex-col gap-1 overflow-y-auto">
      <div
        v-for="admin in adminsOutsideProject"
        :key="admin.id"
        class="flex items-center gap-2 py-1"
      >
        <UserAvatar :user="admin" />
        <div class="min-w-0 flex-1 truncate">{{ admin.username }}</div>
        <SimpleButton size="sm" :text="t('common.Add')" @click="addToProject(admin)" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();

const project = computed(() => store.state.project.project);

// an added admin leaves the list right away; the dialog switches to the time form once the server approves the membership
const adminsOutsideProject = computed(() => store.state.user.workspace.users.filter(u => u.userWorkspace.role === 'ADMIN'
  && !project.value.projectMembers.some(pm => pm.userId === u.id)));

function addToProject(admin) {
  store.dispatch('project/actionInviteUserToProject', { projectId: project.value.id, user: admin });
}
</script>
